import { GuardsCheckEnd, NavigationCancel, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { LanguagesService, Language } from '@shared/services/languages/languages.service';
import { filter } from 'rxjs';
import { FlagComponent } from '../flag/flag.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';

@Component({
    selector: 'language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonToggleGroup, MatButtonToggle, FlagComponent]
})
export class LanguageSelectorComponent implements OnInit {


  @Input() enabledLanguages: string[];
  @Input() emptyLanguages: string[] = [];
  @Input() hideDisabled: boolean;
  @Input() selectedLanguage: Language;
  @Output() selectedLanguageChanged: EventEmitter<Language>;


  languages: Language[];

  constructor(
    private languagesService: LanguagesService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {
    this.selectedLanguageChanged = new EventEmitter();
  }

  ngOnInit(): void {
    this.languages = this.languagesService.getLanguages();
    if (!this.selectedLanguage) {
      // Set the selected language from current language
      this.selectedLanguage = this.languagesService.getCurrentLang();
    }

    if (!this.enabledLanguages) {
      this.enabledLanguages = this.languages.map(l => l.code);
    }
  }

  isDisabled(lang: string): boolean {
    return !this.enabledLanguages.includes(lang);
  }

  isHidden(lang: string): boolean {
    return this.hideDisabled && this.isDisabled(lang);
  }

  markAsEmpty(lang: string): boolean {
    return this.emptyLanguages?.includes(lang);
  }

  onChange(value: Language): void {
    const prevLang = this.selectedLanguage;

    const sub = this.router.events.pipe(
      filter(e => e instanceof GuardsCheckEnd)
    ).subscribe((e: GuardsCheckEnd) => {
      if (!e.shouldActivate) {
        this.selectedLanguage = prevLang;
        this.selectedLanguageChanged.emit(prevLang);
      }
      sub.unsubscribe();
      this.cd.markForCheck();
    });

    this.selectedLanguage = value;
    this.selectedLanguageChanged.emit(value);
  }

}
